"use client";

import { useState } from "react";
import Modal from "..";
import { Button } from "@/components/ui/button";
import Image from "next/image";
import { Logout } from "@/components/icons";
import { signOut } from "next-auth/react";

const LogOutConfirmation = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        className="group inline-flex w-full cursor-pointer gap-2 rounded-md p-2 text-sm font-medium text-slate-700 transition-colors duration-200 hover:bg-red-100 hover:text-red-500"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <Logout className="size-5 transition-colors duration-200 group-hover:text-red-500" />
        Logout
      </button>

      <Modal
        open={open}
        onOpenChange={() => setOpen(false)}
        classes={{ dialogContent: "sm:max-w-[604px]" }}
      >
        <div className="flex flex-col">
          <Image
            src={"/assets/auth/logout.svg"}
            alt="success"
            width={1000}
            height={700}
            className="mx-auto mb-6 h-auto w-full max-w-60 object-contain object-center"
          />
          <h3 className="text-primary mb-2 text-center text-3xl font-semibold">
            Are you sure you want to log out?
          </h3>
          <p className="text-center text-base font-normal text-slate-600">
            You will need to log in again to access your account.
          </p>
          <div className="mt-10 flex w-full justify-between gap-4">
            <Button
              type="button"
              variant="outline"
              className="w-1/2 rounded-full"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                signOut({ callbackUrl: "/login" });
                localStorage.clear();
                localStorage.removeItem("chat_thread");
                localStorage.removeItem("session_id_store");
                localStorage.removeItem("session_id_to_send_store");
                localStorage.removeItem("chat_modal_status");
                localStorage.removeItem("chat_heartbeat");
                localStorage.removeItem("timestamp");
                localStorage.removeItem("requested_admin_support");
                localStorage.removeItem("mark_solved_last_reset");
              }}
              className="w-1/2 rounded-full"
              variant="secondary"
            >
              Logout
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default LogOutConfirmation;
